"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var voucher_1 = require("./voucher");
var common_event_1 = require("./common-event");
var extra_form_data_1 = require("./extra-form-data");
var event_extra_info_1 = require("./event-extra-info");
var organizer_1 = require("./organizer");
var Event = /** @class */ (function (_super) {
    tslib_1.__extends(Event, _super);
    function Event() {
        var _this = _super.call(this, { generateId: false }) || this;
        _this.active = true;
        _this.alias = '';
        _this.steps = new Array();
        _this.extraFormData = new extra_form_data_1.ExtraFormData();
        _this.subEvents = new Array();
        _this.extraInfo = new event_extra_info_1.EventExtraInfo();
        _this.organizer = new organizer_1.Organizer();
        return _this;
    }
    Object.defineProperty(Event.prototype, "short_description", {
        get: function () {
            return this.info.description.split(' ').slice(0, 15).join(' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Event.prototype, "has_card_field_value", {
        get: function () {
            return (this.cardFields || []).some(function (_a) {
                var value = _a.value;
                return !!value;
            });
        },
        enumerable: true,
        configurable: true
    });
    Event.prototype.attachImage = function (image, index) {
        var isEventImage = typeof index !== 'number' ? 'event' : 'subevent';
        if (isEventImage === 'event')
            this.info.image = image;
        else
            this.subEvents[index].info.image = image;
        return this;
    };
    Event.generateVouchers = function (event) {
        return event.uniqueVoucher ? [new voucher_1.Voucher(event.info)] : event.subEvents.filter(function (subEvent) { return subEvent.selected !== false; }).map(function (subEvent) { return new voucher_1.Voucher(subEvent.info); });
    };
    return Event;
}(common_event_1.CommonEvent));
exports.Event = Event;
//# sourceMappingURL=event.js.map